<template>
  <div class="travel-rating">
    <div class="star-rating">
      <div class="star-rating-icons">
        <i v-for="index in 5" :key="index" class="icon icon-star"></i>
      </div>
      <div class="star-rating-icons-overlay">
        <i v-for="index in parseInt(rating/2)" :key="index" class="icon icon-star"></i>
        <i v-if="(rating/2) % 1 >= 0.3" class="icon icon-star-half"></i>
      </div>
    </div>
    <a class="bold-link" title="" data-fancybox="reviews" data-src="#bewertungen-modal" href="#bewertungen-modal">
      <strong v-if="numReviews == 1">{{ numReviews }} Bewertung</strong>
      <strong v-else>{{ numReviews }} Bewertungen</strong>
    </a>
    <p v-if="recommendationRate"><strong>{{ recommendationRate }}%</strong> empfehlen diese Reise weiter</p>
    <div v-if="renderFancybox" id="bewertungen-modal" style="display: none;">
      <div class="ccm-page">
        <div class="container">
          <div class="travel-rating-modal">
            <div class="travel-rating-summary well">
              <h2>{{ title }}</h2>
              <h3>
                <div class="star-rating">
                  <div class="star-rating-icons">
                    <i v-for="index in 5" :key="index" class="icon icon-star"></i>
                  </div>
                  <div class="star-rating-icons-overlay">
                    <i v-for="index in parseInt(rating/2)" :key="index" class="icon icon-star"></i>
                    <i v-if="(rating/2) % 1 >= 0.3" class="icon icon-star-half"></i>
                  </div>
                </div>
                <span class="review-count-text">{{ numReviews }} Bewertungen der Reisenden</span>
              </h3>
              <div v-if="recommendationRate" class="travel-recommend-rating">
                <p>
                  <strong>{{ recommendationRate }}%</strong> empfehlen diese Reise weiter
                </p>
              </div>
              <div id="bewertungen-collapse-modal" class="travel-rating-groups">
                <div class="row">
                  <div class="col-xs-12">
                    <div class="row">
                      <div v-for="s in summary" class="col-xs-12 col-md-6">
                        <div class="travel-group-rating row">
                          <div class="col-xs-12 col-sm-7">
                            <span><strong>{{ s.bezeichnung }}</strong></span>
                          </div>
                          <div class="col-xs-12 col-sm-5">
                            <div class="star-rating">
                              <div class="star-rating-icons">
                                <i v-for="index in 5" :key="index" class="icon icon-star"></i>
                              </div>
                              <div class="star-rating-icons-overlay">
                                <i v-for="index in parseInt(s.bewertung/2)" :key="index" class="icon icon-star"></i>
                                <i v-if="(s.bewertung/2) % 1 >= 0.3" class="icon icon-star-half"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-4">

                  </div>
                </div>
              </div>
            </div>
            <div id="travelReviewFilterForm">
              <div class="row travel-rating-filter-wrapper">
                <div class="col-xs-12 col-sm-7 col-md-8 col-lg-10">
                  <h3>Einzelbewertungen</h3>
                </div>
                <div class="col-xs-12 col-sm-5 col-md-4 col-lg-2">
                  <div class="form-group">
                    <select id="travel-rating-filter" name="travelRatingFilter"
                            class="form-control select2 input-sm" v-model="starFilter">
                      <option value="0">Alle ({{ reviewCount }})</option>
                      <option value="5" :disabled="starCount5 === 0">5 Sterne ({{ starCount5 }})</option>
                      <option value="4" :disabled="starCount4 === 0">4 Sterne ({{ starCount4 }})</option>
                      <option value="3" :disabled="starCount3 === 0">3 Sterne ({{ starCount3 }})</option>
                      <option value="2" :disabled="starCount2 === 0">2 Sterne ({{ starCount2 }})</option>
                      <option value="1" :disabled="starCount1 === 0">1 Stern ({{ starCount1 }})</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="travel-reviews">
                <travel-review-item v-for="(r, index) in reviewsFiltered" :name="r.name"
                                    :key="index"
                                    :index="index"
                                    :date="r.erstelldatum"
                                    :title="r.titel"
                                    :text="r.text"
                                    :comment="r.comment"
                                    :rating-avg="parseFloat(r.bewertung)"
                                    :detail-ratings="r.details"></travel-review-item>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
import TravelReviewItem from './_travel-review-item.vue';

export default {
  name: "travel-rating",
  props: {
    rating: Number,
    numReviews: Number,
    code: String,
    title: String,
    recommendationRate: Number,
    summary: Array,
    reviews: Array,
    renderFancybox: {
      type: Boolean,
      default: true
    }
  },
  components: {
    'travel-review-item': TravelReviewItem,
  },
  data: function () {
    return {
      starFilter: 0,
    }
  },
  filters: {
    toDateString: function(value) {
      return moment(value).format('DD.MM.YY')
    }
  },
  computed: {
    reviewCount: function(){
      return this.reviews.length;
    },
    reviewsFiltered: function(){
      var self = this;
      var res = this.reviews.filter(function(r){
        if(self.starFilter == "1")return r.bewertung <= 3
        else if(self.starFilter == "2")return 3 < r.bewertung && r.bwertung <= 5;
        else if(self.starFilter == "3")return 5 < r.bewertung && r.bewertung <= 7;
        else if(self.starFilter == "4")return 7 < r.bewertung && r.bewertung <= 9;
        else if(self.starFilter == "5")return 9 < r.bewertung;
        else return 1;
      });
      return res;
    },
    starCount1: function(){
      if(this.reviews){
        var res = this.reviews.filter(function(r){
          return r.bewertung <= 3;
        });
        return res.length;
      }
    },
    starCount2: function(){
      if(this.reviews){
        var res = this.reviews.filter(function(r){
          return 3 < r.bewertung && r.bwertung <= 4.6;
        });
        return res.length;
      }
    },
    starCount3: function(){
      if(this.reviews){
        var res = this.reviews.filter(function(r){
          return 4.6 < r.bewertung && r.bewertung <= 6.6;
        });
        return res.length;
      }
    },
    starCount4: function(){
      if(this.reviews){
        var res = this.reviews.filter(function(r){
          return 6.6 < r.bewertung && r.bewertung <= 8.6;
        });
        return res.length;
      }
    },
    starCount5: function(){
      if(this.reviews){
        var res = this.reviews.filter(function(r){
          return 8.6 < r.bewertung;
        });
        return res.length;
      }
    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>
